import { Button, Popconfirm } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

import ModalNovoAtendimento from '../../../../atendimento/Modal/NovoAtendimento';

const App: React.FC<{ record: any }> = ({ record }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Popconfirm
        title="Deseja abrir um chamado na nossa central de atendimento?"
        onConfirm={() => setIsModalOpen(true)}
        onCancel={() => setIsModalOpen(false)}
        okText={
          <span>
            <ModalNovoAtendimento />
          </span>
        }
        okType="text"
        cancelText="Cancelar"
      >
        <Button type="primary" style={{ width: '100%' }} icon={<BugOutlined />}>
          Relatar um problema
        </Button>
      </Popconfirm>
    </>
  );
};

export default App;
